import React from 'react';
import { IconProps } from '../types';
const MinecraftBlazeRod: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="12" y="1" width="1" height="1" fill="rgba(179, 107, 25, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(155, 86, 7, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(168, 109, 27, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(255, 243, 45, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(179, 107, 25, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(255, 248, 126, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(174, 60, 0, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(168, 109, 27, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(255, 248, 126, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(216, 174, 38, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(191, 90, 0, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(179, 107, 25, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(255, 243, 45, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(191, 90, 0, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(168, 109, 27, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(255, 243, 45, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(191, 90, 0, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(168, 109, 27, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(255, 248, 126, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(191, 90, 0, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(179, 107, 25, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(255, 243, 45, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(174, 60, 0, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(179, 107, 25, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(255, 193, 0, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(174, 60, 0, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(168, 109, 27, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(255, 243, 45, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(174, 60, 0, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(179, 107, 25, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(255, 193, 0, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(174, 60, 0, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(177, 91, 16, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(255, 243, 45, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(185, 147, 28, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(191, 90, 0, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(179, 107, 25, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(216, 174, 38, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(191, 90, 0, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(174, 60, 0, 255)" />
</svg>);
export default MinecraftBlazeRod;